import PropTypes from 'prop-types';
import { Autocomplete } from '@atoms';
import { useUserSegmentsProspect } from '@hooks';
import { useSegmentStore } from '@stores';

interface Props {
  disabled?: boolean;
  placeholder?: string;
  error?: string;
  onChange?: (value: string) => void;
}
/**
 * Re-usable Organism component for selecting a user segment.
 * @param {object} props
 * @param {boolean} props.disabled disabled
 * @param {string} props.placeholder placeholder
 * @param {string} props.error error
 * @param {string} props.onChange onChange
 * @returns {React.Component} Segment selector
 */
const SelectSegment = ({ disabled, placeholder, error, onChange }: Props) => {
  const { data, isLoading } = useUserSegmentsProspect();
  const { selectedSegment, setSelectedSegment } = useSegmentStore();

  /**
   * Handles the global selection of segment
   * @param {object} value
   */
  const _onChange = (option: { value: string }) => {
    const { value } = option;
    if (value) {
      setSelectedSegment(value);
      onChange?.(value);
    }
  };

  return (
    <Autocomplete
      isLoading={isLoading}
      disabled={disabled}
      onChange={(_e, value) => _onChange(value)}
      items={data}
      value={selectedSegment}
      parseOption={(item) => ({ label: item.name, value: item.number })}
      isOptionEqualToValue={(option, value) => option.value === value}
      getOptionLabel={(value) => {
        return typeof value === 'object'
          ? value.label ?? ''
          : data?.find((item: { number: string }) => item.number === value)?.name || '';
      }}
      placeholder={placeholder ?? 'COMMON:SELECT_SEGMENT'}
      error={error}
    />
  );
};

SelectSegment.propTypes = {
  disabled: PropTypes.bool,
  placeholder: PropTypes.string,
  error: PropTypes.string,
  onChange: PropTypes.func,
};

export default SelectSegment;
